<template src="../templates/header.html"></template>
<script>

	import objLogo from '@/assets/logo1.png';
	import {authorizationService} from '../authorization/authorizationService';
	import MenuCollection from '@/collections/menuCollection';
	import {EventBus} from "../event-bus";
  const _ = require('lodash');

	export default {
		name: 'headerComponent',
		props: {
			propUserName: String
		},
		data() {
			return {
				menuCollection: new MenuCollection(),
				routeName: this.$route.name,
				activeIndex: '1',
				imgLogo: objLogo,
				authorisedMenuToDisplay: [],
				welcomeVisible: false,
				contactsVisible: false,
				dynamicFormVisible: false,
				duplicateFormVisible: false,
				searchJobsVisible: false,
				searchDhsJobsVisible: false,
				outstandingInvoicesVisible: false,
				uploadsVisible: false,
				resetPasswordVisible: false,
				userVisible: false,
				groupsVisible: false,
				dashboardVisible: false,
				jobsVisible: false,
				bookInterpretersVisible: false,
				reportsVisible: false,
				actionsVisible: false,
				isAdmin: false,
				isToggleable: 'sm',
				windowWidth: 0,
				windowHeight: 0,
				show: false,
				stopChildMenuCheck: false,
				drop_down_hide: false,
				noChildrenAtAll: false,
				actionsDefault: true,
				noActionsChildren: false,
				resetPasswordShow: false,
				menuItems: [],
				menuItemsIndexed: [],
				isDataLoading: false
			};
		},
		watch: {
			'$route': 'getMenu'
		},
		created() {
			this.isAdmin = localStorage.getItem("isAdmin") === "true";
			this.getMenu();
		},
		mounted() {
			Event.$on('rebuildMenu', () => {
				this.getMenu();
			});

			Event.$on('disableEventTrigger', (status) => {
				this.isDataLoading = status;
			});

			EventBus.$on('resetMenuList', () => {
				this.actionsDefault = false;
			});

			this.$nextTick(function () {
				window.addEventListener('resize', this.getWindowWidth);
				window.addEventListener('resize', this.getWindowHeight);

				//Init
				this.getWindowWidth();
				this.getWindowHeight()
			})
		},
		methods: {
			stopCheck() {
				this.stopChildMenuCheck = false;
			},
			logOut() {

				localStorage.removeItem("jwt");
				localStorage.removeItem('userName');
				localStorage.removeItem('isAdmin');
				localStorage.removeItem('contactId');
				localStorage.removeItem('pageSize');
				this.noChildrenAtAll = false;

				this.$router.push("/login");
			},
			getUserName() {
				return localStorage.getItem("userName");
			},
			goToPage(routeName) {
        if(routeName === '/ResetPassword') {
          this.redirectToReset();
        } else {
          this.$router.push(routeName);
        }

			},
			redirectToReset() {
				this.$root.$router.push({
					path: `/ResetPassword/${localStorage.getItem("jwt")}/no`, // no here means it's not generated through email link
				});
				// this.$router.push("ResetPassword",);
				// window.location.href = '/#ResetPassword/' + ;
			},
			redirect(routeName) {
				window.location.href = '/#' + routeName;
			},
			// @mj - For Media Query using Vue
			getWindowWidth(event) {
				this.windowWidth = window.innerWidth;

				// Note: 1240 is equivalent to 930px (difference of 310)
				if (this.windowWidth <= 1400) {
					this.isToggleable = '';
				} else {
					this.isToggleable = 'xl';
				}
			},
			getWindowHeight(event) {
				this.windowHeight = window.innerHeight;
			},

      hasActionsWithLogout(array) {
        return array.some(item =>
          item.menu_name === "Actions" &&
          item.childMenu.some(child => child.menu_name === "logout")
        );
      },
			getMenu() {
				if (this.$route.params.isEmailLink == 'yes') {

					this.actionsDefault = false;
				}
				else {

					this.menuCollection.fetch(
						{
							'url': this.menuCollection.getRoute('fetch')
						}
					).then(() => {

						this.menuItems = [];
						this.menuItemsIndexed = [];
						let ifCounter = 0;
						let elseCounter = 0;
						let resetCounter = 0;
						this.menuCollection.models.forEach((model, index) => {

              this.menuItemsIndexed.push({
                childMenu: model.childMenu,
                path: model.path,
                menu_name: model.menu_name,
                order: model.order,
              });

							// if (model.guestDefault === 1) {
							// 	if (model.parentDetails != null && model.path != null ) {

							// 		this.menuItems[index] = {
							// 			accessPointId: model.parentDetails.accessPointId,
							// 			childMenu: model.childMenu,
							// 			linkMenu: model.linkMenu,
							// 			client_portal_menu_id: model.parentDetails.client_portal_menu_id,
							// 			contact_id: model.contact_id,
							// 			guestDefault: model.guestDefault,
							// 			it_project_id: model.it_project_id,
							// 			menu_name: model.parentDetails.menu_name,
							// 			order: model.parentDetails.order,
							// 			parent: null,
							// 			path: null
							// 		};
							// 	}
							// 	else if (model.path != null) {

							// 		this.menuItems[index] = model.attributes;
							// 	}
							// }
							// else {
							// 	this.menuItems[index] = model;
							// }

						})

            this.actionsDefault = !this.hasActionsWithLogout(this.menuItemsIndexed);

						// this.menuItems.forEach((model) => {

						// 	// Assign the value to the specified index to form a order.
						// 	this.menuItemsIndexed[parseInt(model.order) - 1] = model;

						// });

						// If item is empty or null in an array, remove them and shift the index to fill the gap.
						// this.menuItemsIndexed = this.filter_array_values(this.menuItemsIndexed);
						this.noActionsChildren = false;

						// this.menuItemsIndexed.forEach((model) => {

						// 	if (model.childMenu.length === 0) {
						// 		if (model.menu_name === 'Actions') {
						// 			elseCounter = 0;

						// 			this.resetPasswordShow = true;
						// 		}
						// 		else {
						// 			ifCounter++;

						// 			this.resetPasswordShow = false;
						// 		}
						// 	}
						// 	else {

						// 		if (model.menu_name === 'Actions') {
						// 			elseCounter++;

						// 			model.childMenu.forEach((item) => {

						// 				if (item.menu_name === 'Reset Password') {
						// 					this.resetPasswordShow = false;
						// 					resetCounter++;
						// 				}
						// 				else {
						// 					if (resetCounter > 0) this.resetPasswordShow = false;
						// 					else this.resetPasswordShow = true;
						// 				}
						// 			})
						// 		}
						// 	}
						// });

						// if (ifCounter === this.menuCollection.models.length) {
						// 	this.actionsDefault = true;
						// }
						// else {
						// 	if (elseCounter > 0) {
						// 		this.actionsDefault = false;
						// 	}
						// 	else {
						// 		this.actionsDefault = true;
						// 	}
						// }

            console.log('this.menuItemsIndexed', this.menuItemsIndexed);

            // const result = _.find(this.menuCollection.models, { menu_name: "Translations Form" });
            console.log("🚀 ~ ).then ~ this.menuCollection.models:", this.menuCollection.models)
            // console.log("🚀 ~ ).then ~ result:", result)

            // this.menuItemsIndexed.splice(3, 0, result);
            // console.log("🚀 ~ ).then ~ this.menuItemsIndexed:", this.menuItemsIndexed)

					}).catch((error) => {
						console.error(error);
					});



				}
			},
			filter_array_values(arr) {
				arr = arr.filter(this.isEligible);
				console.log("🚀 ~ filter_array_values ~ arr:", arr)
				return arr;
			},
			isEligible(value) {
				if (value !== false || value !== null || value !== 0 || value !== "") {
					return value;
				}
			},
		}
	}
</script>


<style>


	@media (min-width: 930px) {
		/*.navbar-toggler {*/
		/*display: block;*/
		/*}*/
		.navbar-nav {
			/*display: none;*/
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/header.vue